// extracted by mini-css-extract-plugin
export default {"bannerText":"OfferPreviewPage_bannerText__ff0Sh"};